export const PERMISSIONS = {
  MANAGE_TENANT_ADMINS: "tenant.manage_admins",
  MANAGE_EMPLOYEE_USERS: "tenant.manage_employees",
  MANAGE_SSO: "tenant.manage_sso",
  MANAGE_TENANT_ROLES: "tenant.manage_roles",
  ASSIGN_TENANT_ROLES: "tenant.assign_roles",
  ACCOUNTING_WORK: "accounting.work",
  ACCOUNTING_REPORTS: "accounting.reports",
  MANAGE_CLIENT_PROFILES: "clients.manage_profiles",
};

export const PERMISSION_LABELS = {
  "tenant.manage_admins": "Manage Tenant Admins",
  "tenant.manage_employees": "Manage Employee Users",
  "tenant.manage_sso": "Manage SSO Settings",
  "tenant.manage_roles": "Manage Tenant Roles",
  "tenant.assign_roles": "Assign Tenant Roles",
  "accounting.work": "Accounting Work",
  "accounting.reports": "Accounting Reports",
  "clients.manage_profiles": "Manage Client Profiles",
};

export const ALL_PERMISSIONS = Object.values(PERMISSIONS);

export const DEFAULT_PERMISSIONS_BY_BASE_ROLE = {
  super_admin: ALL_PERMISSIONS,
  tenant_admin: [
    PERMISSIONS.MANAGE_EMPLOYEE_USERS,
    PERMISSIONS.MANAGE_SSO,
    PERMISSIONS.MANAGE_TENANT_ROLES,
    PERMISSIONS.ASSIGN_TENANT_ROLES,
    PERMISSIONS.ACCOUNTING_WORK,
    PERMISSIONS.ACCOUNTING_REPORTS,
    PERMISSIONS.MANAGE_CLIENT_PROFILES,
  ],
  supervisor: [
    PERMISSIONS.ACCOUNTING_WORK,
    PERMISSIONS.ACCOUNTING_REPORTS,
    PERMISSIONS.MANAGE_CLIENT_PROFILES,
    PERMISSIONS.ASSIGN_TENANT_ROLES,
  ],
  user: [PERMISSIONS.ACCOUNTING_WORK, PERMISSIONS.MANAGE_CLIENT_PROFILES],
  visitor: [],
};


